export function startTracking(onSuccess, onError) {
  // Вместо реального GPS запускаем симуляцию ходьбы
  let currentLat = 55.7558; // Стартовая точка (например, Москва)
  let currentLng = 37.6173;

  const intervalId = setInterval(() => {
    // Имитируем небольшое движение (прибавляем случайный шаг)
    currentLat += (Math.random() - 0.5) * 0.001;
    currentLng += (Math.random() - 0.5) * 0.001;

    onSuccess({
      latitude: currentLat,
      longitude: currentLng,
      accuracy: 10, // имитируем высокую точность GPS
      isPrecise: true
    });
  }, 3000); // Обновляем координаты каждые 3 секунды

  // Возвращаем intervalId вместо watchId, чтобы stopTracking мог его очистить
  return intervalId;
}

export function stopTracking(watchId) {
  clearInterval(watchId);
}